import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService } from 'ng-jhipster';

import { Reservation } from './reservation.model';
import { ReservationService } from './reservation.service';
import { ReservationUtilService } from './reservation.util.service';
import { ITEMS_PER_PAGE, Principal } from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { SchoolCalendar, SchoolCalendarService} from '../../entities/school-calendar';

import { StudentService } from '../../entities/student/student.service';
import { Student } from '../student/student.model';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-reservation',
    templateUrl: './reservation.component.html'
})
export class ReservationComponent implements OnInit, OnDestroy {

    currentAccount: any;
    reservations: Reservation[];
    error: any;
    success: any;
    eventSubscriber: Subscription;
    currentSearch: string;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;

    // for the search functions
    currentSchoolCalendar: SchoolCalendar = new SchoolCalendar();
    totalBillableReservations: number = 0;
    totalAttendedReservations: number = 0;
    totalNoShowReservations: number = 0;
    totalNewReservations: number = 0;
    totalCancelledReservations: number = 0;
    reservationsCalendarFrom: NgbDateStruct;
    reservationsSearchFrom: Date;
    reservationsCalendarTo: NgbDateStruct;
    reservationsSearchTo: Date;
    reservationsCalendarToMinDate: NgbDateStruct;
    reservationsCalendarToMaxDate: NgbDateStruct;
    currentStudent: Student;
    currentUserIsStudent: boolean;
    isReservationsSearching: boolean;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private reservationService: ReservationService,
        private schoolCalendarService: SchoolCalendarService,
        private studentService: StudentService,
        private parseLinks: ParseLinks,
        private alertService: AlertService,
        private principal: Principal,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private eventManager: EventManager,
        private paginationUtil: PaginationUtil,
        private paginationConfig: PaginationConfig,
        private reservationUtilService: ReservationUtilService
    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data['pagingParams'].page;
            this.previousPage = data['pagingParams'].page;
            this.reverse = data['pagingParams'].ascending;
            this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';

        if (this.currentSearch) {
            this.reservationsCalendarFrom = {
                year: parseInt(activatedRoute.snapshot.params['yearFrom'], 10),
                month:  parseInt(activatedRoute.snapshot.params['monthFrom'], 10),
                day:  parseInt(activatedRoute.snapshot.params['dayFrom'], 10)
            };

            this.reservationsCalendarTo = {
                year: parseInt(activatedRoute.snapshot.params['yearTo'], 10),
                month:  parseInt(activatedRoute.snapshot.params['monthTo'], 10),
                day:  parseInt(activatedRoute.snapshot.params['dayTo'], 10)
            };

        }
        this.jhiLanguageService.setLocations(['reservation', 'reservationStatus',
         'enrollment', 'card', 'lesson', 'payment', 'paymentType', 'paymentItem']);
    }

    ngOnInit() {
        this.principal.identity().then((account) => {
            this.currentAccount = account;
            this.principal
            .hasOnlyAuthority('ROLE_USER')
            .then((res) => {
                if (res) {
                    // The current user is a student
                    this.currentUserIsStudent = true;
                }
            });

            this.studentService.getCurrent().subscribe((student: any) => {
                this.currentStudent = student;

                this.schoolCalendarService
                    .current()
                    .subscribe(
                        (res: HttpResponse<SchoolCalendar[]>) => {
                            let calendars = res.body;
                            if (calendars.length > 0 ) {
                                this.currentSchoolCalendar = calendars[0];
                            } else {
                                this.currentSchoolCalendar = null;
                            }
                            this.initReservationsCalendar();
                            this.loadReservations();
                        },
                        (res: HttpErrorResponse) => this.onError(res));
            });

            this.registerChangeInReservations();
        });
    }

    loadReservations() {
        this.currentSearch = 'student.id:' + this.currentStudent.id + ' AND '
                             + this.getDateRangeQuery(this.reservationsCalendarFrom, this.reservationsCalendarTo);

        let searchParams = this.getDateSearchParams(this.reservationsCalendarFrom, this.reservationsCalendarTo);

        this.reservationService.search({
            page: this.page - 1,
            query: this.currentSearch,
            size: this.itemsPerPage,
            sort: this.sort(),
            ...searchParams
        }).subscribe(
            (res: HttpResponse<Reservation[]>) => this.onSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
            );

        this.loadReservationsCount();
    }

    private loadReservationsCount() {
        if (!this.currentSearch) {
            return;
        }
        // count the new reservations
        let countNewReservationsQuery: string = '!(lesson.free:true) AND status:NEW ' + this.currentSearch;
        this.reservationService.count({query : countNewReservationsQuery})
                               .subscribe(
                                (res: number) => this.totalNewReservations = res,
                                (res: HttpErrorResponse) => this.onError(res)
                                );

        // count the attended reservations
        let countAttendedReservationsQuery: string = '!(lesson.free:true) AND status:ATTENDED ' + this.currentSearch;
        this.reservationService.count({query : countAttendedReservationsQuery})
                               .subscribe(
                                (res: number) => this.totalAttendedReservations = res,
                                (res: HttpErrorResponse) => this.onError(res)
                                );

         // count the no show reservations
        let countNoShowReservationsQuery: string = '!(lesson.free:true) AND status:NO_SHOW ' + this.currentSearch;
        this.reservationService.count({query : countNoShowReservationsQuery})
                                .subscribe(
                                 (res: number) => this.totalNoShowReservations = res,
                                 (res: HttpErrorResponse) => this.onError(res)
                                 );
        // count the cancelled reservations ( cancelled by the user or because the lesson was cancelled)
        let countCancelledReservationsQuery: string =
        '!(lesson.free:true) AND (status:CANCELLED OR status:LESSON_CANCELLED) ' + this.currentSearch;
        this.reservationService.count({query : countCancelledReservationsQuery})
                               .subscribe(
                                (res: number) => this.totalCancelledReservations = res,
                                (res: HttpErrorResponse) => this.onError(res)
                                );
        // count the billable reservations
        let countTotalBillableReservationsQuery: string = '!(lesson.free:true) AND '
        + ' !(status:CANCELLED) AND !(status:LESSON_CANCELLED) AND ' + this.currentSearch;
        this.reservationService.count({query : countTotalBillableReservationsQuery})
                               .subscribe(
                                (res: number) => this.totalBillableReservations = res,
                                (res: HttpErrorResponse) => this.onError(res)
                                );
    }

    private getDateRangeQuery(fromDate: NgbDateStruct, toDate: NgbDateStruct) {
        let fromDateTerm: String;
        let toDateTerm: String;

        if (fromDate) {
            let fromMonth: number = fromDate.month;
            let fromDay: number = fromDate.day;

            fromDateTerm = fromDate.year + '-'
                + (fromMonth < 10 ? '0' + fromMonth : fromMonth)
                + '-' + (fromDay < 10 ? '0' + fromDay : fromDay);
        } else {
            fromDateTerm = '*';
        }

        if (toDate) {
            let realToDate = new Date(toDate.year, toDate.month - 1, toDate.day);
            realToDate.setDate(realToDate.getDate());
            let toDay = realToDate.getDate();
            let toMonth = realToDate.getMonth() + 1 ;
            toDateTerm = realToDate.getFullYear() + '-'
                + (toMonth < 10 ? '0' + toMonth : toMonth )
                + '-'  + (toDay < 10 ? '0' + toDay : toDay);

        } else {
            toDateTerm = '*';
        }

        return 'lesson.begining:[ ' + fromDateTerm + ' TO ' + toDateTerm + ']';
    }

    getDateSearchParams(searchDateFrom: NgbDateStruct, searchDateTo: NgbDateStruct) {
        let result: any = {};

        if (searchDateFrom) {
            result.yearFrom = searchDateFrom.year;
            result.monthFrom = searchDateFrom.month;
            result.dayFrom = searchDateFrom.day;
        }

        if (searchDateTo) {
            result.yearTo = searchDateTo.year;
            result.monthTo = searchDateTo.month;
            result.dayTo = searchDateTo.day;
        }

        return result;
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        this.router.navigate(['/reservation'], {
            queryParams:
            {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc'),
                ...this.getDateSearchParams(this.reservationsCalendarFrom, this.reservationsCalendarTo)
            }
        });
        this.loadReservations();
    }

    clear() {
        this.page = 0;
        this.currentSearch = '';
        this.isReservationsSearching = false;
        this.initReservationsCalendar();
        this.loadReservations();
    }

    search() {
        this.isReservationsSearching = true;
        this.page = 0;
        let dateSearchParams = this.getDateSearchParams(this.reservationsCalendarFrom, this.reservationsCalendarTo);
        this.loadReservations();
        this.router.navigate(['/reservation', {
            search: this.currentSearch,
            page: this.page,
            sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc'),
            ...dateSearchParams
        }]);
    }

    /**
     * Returns true if all validations to activate the search button pass.
     */
    isSearchActive() {
            return this.isDateRangeValid(this.reservationsCalendarFrom, this.reservationsCalendarTo);
    }

     /**
     * Returns true whether the specified date range is valid; false otherwise.
     * */
    isDateRangeValid(fromDateInput, toDateInput) {
        if (fromDateInput && toDateInput) {
            let fromDate = new Date(fromDateInput.year, fromDateInput.month - 1, fromDateInput.day);
            let toDate = new Date(toDateInput.year, toDateInput.month - 1, toDateInput.day);

            return (fromDate <= toDate);
        }

        return true;
    }

    private initReservationsCalendar() {
        let fromDate: Date;
        let toDate: Date;

        // We initialize the UI filters.
        // If there is a current school calendar we use it
        if (this.currentSchoolCalendar) {
            fromDate = new Date(this.currentSchoolCalendar.begining);
            toDate = new Date(this.currentSchoolCalendar.ending);
            this.reservationsCalendarFrom = this.fromDate(fromDate);
            this.reservationsCalendarTo = this.fromDate(toDate);
        } else {
            // We initialize the FROM date with 7 days before the TO date or the min date of the calendar
            toDate = new Date();
            fromDate = new Date();
            fromDate.setDate(toDate.getDate() - 7);
            this.reservationsCalendarFrom = this.fromDate(fromDate);
            this.reservationsCalendarTo = this.fromDate(toDate);
        }

        this.reservationsSearchFrom = new Date(fromDate);
        this.reservationsSearchTo = new Date(toDate);
    }

    private fromDate(date: Date): NgbDateStruct {
        if (date) {
            return {
                day: date.getDate(),
                month: date.getMonth() + 1,
                year: date.getFullYear()
            };
        }

        return {
            day: 18,
            month: 3,
            year: 1951
        };
    }

    private toDate(jsonDate: Object): Date {
        if (jsonDate !== null) {
            let year = jsonDate['year'];
            let month = jsonDate['month'];
            let day = jsonDate['day'];

            if (year != null && month != null && day != null) {
                let d = new Date();
                d.setDate(day);
                d.setFullYear(year);
                d.setMonth(month - 1);

                return d;
            }
        }

        return null;
    }


    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: Reservation) {
        return item.id;
    }

    registerChangeInReservations() {
        this.eventSubscriber = this.eventManager.subscribe('reservationListModification', (response) => this.loadReservations());
    }

    getReservationBadgeStyle(reservation: Reservation): String {
        if (reservation) {
            return this.reservationUtilService.getReservationBadgeStyle(
                reservation.status.toString());
        }
        return 'badge-info';
    }

    sort() {
        let result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        return result;
    }

    private reservationCalendarfromDateChanged(fromDate: NgbDateStruct) {
        if (!fromDate) {
            return;
        }

        // We set the min date of the toCalendar the same date fromDate
        let minDate: Date = new Date(fromDate.year, fromDate.month - 1, fromDate.day);
        this.reservationsCalendarToMinDate = {
            year: minDate.getFullYear(),
            month: minDate.getMonth() + 1,
            day: minDate.getDate()
        };

        // We set the max date of the toCalendar to one year from the fromDate
        let maxDate: Date = new Date(fromDate.year, fromDate.month - 1 + 12 , fromDate.day);
        this.reservationsCalendarToMaxDate = {
            year: maxDate.getFullYear(),
            month: maxDate.getMonth() + 1,
            day: maxDate.getDate()
        };
    }


    private belongsToProduct(reservation: Reservation) {
        return reservation.lesson.free === true || this.reservationUtilService.belongsToProduct(reservation);
    }

    private getPaymentMethod(reservation: Reservation) {
        return this.reservationUtilService.getPaymentMethod(reservation);
    }

    private getPayedByProductIcon() {
        return this.reservationUtilService.getPayedByProductIcon();
    }

    private getNotPayedByProductIcon() {
        return this.reservationUtilService.getNotPayedByProductIcon();
    }

    private onSuccess(data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.reservations = data;
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation/reservation.component.ts